"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.RPCHTTPClient = void 0;
var error_1 = require("./error");
var RPCHTTPClient = /** @class */ (function () {
    function RPCHTTPClient(ky, prefixUrl, tokenGetter) {
        this.prefixUrl = prefixUrl;
        this.tokenGetter = tokenGetter;
        this.client = ky.extend({
            prefixUrl: prefixUrl,
            hooks: {
                beforeRequest: [this.beforeRequest.bind(this)]
            }
        });
    }
    RPCHTTPClient.prototype.beforeRequest = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenGetter()];
                    case 1:
                        token = _a.sent();
                        if (token) {
                            opts.headers.set("Authorization", "Bearer ".concat(token));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RPCHTTPClient.prototype.handleResponse = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var r, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, response];
                    case 1:
                        r = _a.sent();
                        if (!(r.headers.get("Content-Type") != "application/json")) return [3 /*break*/, 2];
                        throw error_1.HttpErrors.JsonExpected;
                    case 2: return [4 /*yield*/, r.json()];
                    case 3:
                        json = _a.sent();
                        if (r.ok) {
                            return [2 /*return*/, json];
                        }
                        else {
                            throw json;
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RPCHTTPClient.prototype.call = function (service, method, body) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                url = "rpc/".concat(service, "/").concat(method);
                res = this.client.post(url, {
                    json: body
                });
                return [2 /*return*/, this.handleResponse(res)];
            });
        });
    };
    return RPCHTTPClient;
}());
exports.RPCHTTPClient = RPCHTTPClient;
//# sourceMappingURL=Client.js.map